<template>
  <div class="newzone" :class="{ inApp: $root.$data.isApp }">
    <common-title titleName="新人专区" :bcColor="'#FEFEFF'" :zIndex="1000" :goHome="true" />
    <h2>恭喜，您已获得新人课程礼包</h2>
    <h3>(可前往APP，学习页面查看课程)</h3>
    <div class="centerBox" v-if="courseInfo">
      <div
        class="courseItem"
        v-for="(item, index) in courseInfo"
        :key="index"
        @click="enterDetails(item)"
      >
        <img :src="item.coverMobile" alt="cover" />
        <div class="rightCourseInfo">
          <h3 class="ellipsis">{{ item.name }}</h3>
          <span>{{ item.classPeriod }}课时</span>
          <ul>
            <li>{{ item.salesVolume }}人报名</li>
            <!-- 售价 -->
            <div class="coursePrice">
              <!-- <del v-if="item.originalPrice">￥{{ item.originalPrice }}</del> -->
              <span
                class="courseType"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
                >拼团价</span
              >
              <span v-else-if="item.promotionLabel" class="courseType">{{
                item.promotionLabel === 1
                  ? '折后价'
                  : item.promotionLabel === 4
                  ? '券后价'
                  : '限时价'
              }}</span>
              <p class="showPic">
                <template
                  v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
                >
                  <b>¥</b>
                  <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
                </template>
                <template v-else>
                  <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
                  <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                    item.sellPrice === 0 && !item.promotionLabel ? '免费' : item.sellPrice
                  }}</span>
                </template>
              </p>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <h2>快来领取你的专属优惠券吧～</h2>
    <div class="counponBox" v-if="couponList">
      <div class="counponItem" v-for="(item, index) in couponList" :key="index">
        <CouponCard :couponInfo="item" :orderType='true' class="couppon_card">
          <div class="slot">
            <button @click="receiveCoupon(item, index)" v-if="!item.alreadyGet">领取</button>
            <img v-else src="../../assets/img/productDetail/receive_success.png" alt="" /></div
        ></CouponCard>
      </div>
    </div>

    <div class="consult">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/login/phoneIcon.png" alt="" />
      <div class="consultCenter">
        <span>1V1&nbsp;&nbsp;&nbsp;&nbsp;考研规划咨询</span>
        <div @click="openChat">立即咨询</div>
      </div>
    </div>

    <div class="startStudy">
      <span @click="goHome">开启学习之旅</span>
    </div>
    <CommonLoading :loading="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqNewzoneGift, reqCouponList } from '@/api/newUser';
import { reqReceiveCoupon } from '@/api/coupon/index';
import { reqProducts } from '@/api/home';
import { resetProductData, getRegisterSourceInfo, setTokenFromCookie } from '@/utils/tools';
import CouponCard from '@/components/coupon/CouponCard.vue';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';

export default {
  components: {
    CommonTitle,
    CouponCard,
    CommonLoading,
  },
  data() {
    return {
      courseInfo: null,
      couponList: null,
    };
  },

  computed: {
    loading() {
      let load = true;
      if (this.couponList || this.courseInfo) {
        load = false;
      }
      return load;
    },
    ...mapState(['userInfo']),
  },
  created() {
    this.getGitList();
  },
  mounted() {},

  methods: {
    async getGitList() {
      const res = await reqNewzoneGift();
      if (res?.code === 0) {
        const list = res?.data;
        const courseIds = [];
        const couponIds = [];
        // eslint-disable-next-line no-unused-expressions
        list?.map((item) => {
          if (item.type === 1) {
            courseIds.push(item.productId);
          }
          if (item.type === 2) {
            couponIds.push(item.couponId);
          }
        });

        this.getCouponDetail(couponIds);
        this.getCourseInfo(courseIds);
      }
    },

    // 根据优惠券id集合 查询优惠券信息
    async getCouponDetail(couponIds) {
      if (!couponIds.length) return;
      const ids = `couponId=${couponIds?.map((item) => item).join('&couponId=')}`;
      const { code, data } = await reqCouponList(ids);
      if (code === 0 && data) {
        this.couponList = data;
        this.couponList.forEach((element) => {
          let dateTimeInfo = null;
          if (element.effectiveTimeType === 1) {
            dateTimeInfo = `领取后${element.effectiveDays}天内有效`;
          } else {
            dateTimeInfo = `${element.effectiveTimeBegin}-${element.effectiveTimeEnd}`;
          }
          Object.assign(element, { dateTimeInfo, couponName: element.frontEndName });
        });
      }
    },
    // 课程信息
    async getCourseInfo(courseIds) {
      if (!courseIds.length) return;
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = await reqProducts(courseIds, endPoint);
      if (res?.code === 0 && res?.data) {
        this.courseInfo = resetProductData(res?.data || []);
      }
    },
    // 进入详情
    enterDetails(courseInfo) {
      sessionStorage.setItem('back', true);
      const { productId } = courseInfo;
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(productId), false);
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
          },
        });
      }
    },
    openChat() {
      if (this.$root.$data.isApp) {
        // this.$sendToApp(
        //   'openNewWebView',
        //   {
        //     url: 'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=62da2340be8c8a0001b0e211',
        //   },
        //   false,
        // );
        return;
      }
      // window.open(
      //   'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=62da2340be8c8a0001b0e211',
      // );
    },
    goHome() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToHomePage');
        return;
      }
      this.$router.push({
        path: '/home',
        query: {
          code: 8,
        },
      });
    },
    async receiveCoupon(item, index) {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          getRegisterSourceInfo(this, 'newZone', 5, true);
        } else {
          const param = { redirect: '/newZone', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
        return;
      }
      const res = await reqReceiveCoupon({
        couponId: String(item.couponId),
        couponVersion: Number(item.couponVersion),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark
      });
      if (res.code === 0) {
        this.$toast('领取成功');
        this.getGitList();
      } else {
        this.$toast(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// ::v-deep .couponGet {
//   display: none;
// }
.newzone {
  width: 100%;
  padding-top: 100px;
  padding-bottom: 160px;
  h2 {
    padding: 43px 0 20px 0;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
    text-align: center;
  }
  h3{
    padding-bottom: 43px;
    color: #aaa;
    font-weight: 500;
    font-size: 26px;
    line-height: 40px;
    text-align: center;
  }
  .centerBox {
    width: 678px;
    margin: 0 auto 22px auto;
    padding: 7px 29px;
    background: #fff;
    border-radius: 14px;
    .courseItem {
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 25px 0 14px 0;
      border-bottom: 2px solid #f5f5f5;
      img {
        width: 163px;
        height: 118px;
        margin-right: 22px;
        border-radius: 14px;
      }
      .rightCourseInfo {
        width: 435px;
        h3 {
          color: #333;
          font-weight: 500;
          font-size: 25px;
          line-height: 33px;
        }
        span {
          display: block;
          // line-height: 31px;
          margin: 11px 0 13px 0;
          color: #999;
          font-weight: 400;
          font-size: 22px;
        }
        ul {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          li:nth-child(1) {
            color: #999;
            font-weight: 400;
            font-size: 22px;
            line-height: 31px;
          }
          .coursePrice {
            display: flex;
            align-items: baseline;

            .courseType {
              color: #ff3938;
              font-weight: 500;
              font-size: 20px;
            }
            .showPic {
              display: flex;
              align-items: baseline;
              margin-left: 6px;
              font-weight: 400;
              font-size: 25px;
              text-align: center;
              b {
                margin: 0 4px;
                color: #ff3938;
                font-size: 20px;
              }
              span {
                color: #ff3938;
                font-weight: 400;
                font-size: 25px;
              }
              .fontSty {
                font-size: 25px;
              }
            }
          }
        }
      }
    }
    .courseItem:last-child {
      border-bottom: none;
    }
  }
  .counponBox {
    .counponItem {
      width: 678px;
      height: 192px;
      margin: 0 auto;
      margin-bottom: 22px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/login/bg.png');
      background-size: 100% 100%;
      .slot {
        position: absolute;
        top: 15px;
        right: 36px;
        z-index: 100;
        display: flex;
        align-items: center;
        height: 100%;
        button {
          width: 109px;
          height: 43px;
          color: #fff;
          font-size: 22px;
          line-height: 43px;
          text-align: center;
          background: #ff6c02;
          border: none;
          border-radius: 29px;
        }
        img {
          width: 116px;
        }
      }
      // .couponInfo >>> .couponGet {
      //   display: none;
      // }
    }
  }
  .consult {
    position: relative;
    width: 678px;
    height: 127px;
    margin: 0 auto;
    background: linear-gradient(180deg, rgb(255, 225, 202, 0.4) 0%, rgb(255, 255, 255, 0.4) 100%);
    border: 1px solid #ffc2a5;
    border-radius: 14px;
    img {
      position: absolute;
      bottom: 0;
      left: 16px;
      width: 129px;
      height: 112px;
    }
    .consultCenter {
      display: flex;
      justify-content: space-between;
      padding: 40px 29px 0 123px;

      span {
        color: #333;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }
      div {
        height: 42px;
        padding: 0 20px;
        color: #fff;
        font-weight: 500;
        font-size: 22px;
        line-height: 42px;
        background: #ff7f41;
        border-radius: 22px;
      }
    }
  }
  .startStudy {
    position: fixed;
    bottom: 80px;
    z-index: 110;
    width: 100%;
    span {
      display: block;
      width: 636px;
      height: 82px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 82px;
      text-align: center;
      background: #ff7f41;
      border-radius: 45px;
    }
  }
}

.inApp {
  padding-top: 0;
}
//  ::v-deep .couponGet {
//         display: none;
//       }
</style>
